import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';
import { Response_GeneralCDMS } from 'src/app/Interfaces/GeneralCDMS/Response_GeneralCDMS.interface';
import { Create_RiskOpportunities, RiskOpportunities } from 'src/app/Interfaces/GeneralCDMS/RiskOpportunities.interface';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { FILE_CAP } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';
import { PermisionsFolderService } from 'src/app/Services/Global/Permissions/permisions-folder.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-risks-opportun-cdms',
    templateUrl: './risks-opportun-cdms.component.html',
    styleUrls: ['./risks-opportun-cdms.component.scss', './../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class RisksOpportunCDMSComponent implements OnInit {

  @ViewChild('AddRiskOpportunities')
  MyInputAddRiskOpportunities!: ElementRef;

  //+================== VARIABLES BAND FOR UPDATE OR NEW LOAD ==================+\\
  public IsUpdate: boolean = false;


  //+================== VARIABLES GLOBAL FILES RISK AND OPPORTUNITIES ==================+\\
  public All_RiskOpportunitiess: RiskOpportunities[] = [];


  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;


  //+================== VARIABLES FILES ==================+\\
  public FileAuxAddRiskOpportunities: FILE_CAP = { FileData: null, FileName: '' };
  public RiskOpportunities_Selected: RiskOpportunities = {
    ID: 0,
    ID_Contributor: 0,
    Name: '',
    Extension: '',
    Status: 0,
    ID_Next_Version: 0,
    ID_Previous_Version: 0,
    Upload_Date: null,
  }

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //-========================= SERVICES =========================-\\
  public UserService = inject(UserDataService);
  private Service_GeneralCDMS = inject(GeneralCDMSService);
  private PermissionFolder = inject(PermisionsFolderService);
  private Service_FIN = inject(LibraryFINService); // FOR DOWNLOAD FILES

  constructor() { }

  ngOnInit(): void {
    this.Load_Component();
  }
  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTION FOR LOAD COMPONENT ==================-\\
  private async Load_Component(): Promise<void> {
    this.LoadPage = false;
    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {
      await this.Load_All_RiskOpportunitiess();

      Loader.classList.remove('active');
      this.LoadPage = true;
    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (RiskOpportunities)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      }); Loader.classList.remove('active');
    }
  }

  //-================== FUNCTION FOR LOAD RISKOPPORTUNITIES ==================-\\
  private async Load_All_RiskOpportunitiess(): Promise<boolean> {
    try {

      const Response_RiskOpportunities: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Get_RiskOpportunities_CDMS());

      if (Response_RiskOpportunities.success) {
        this.All_RiskOpportunitiess = Response_RiskOpportunities.operation;
      }

      return true;
    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (RiskOpportunities)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return true;
    }
  }


  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION RETURN CLASS FILE ==================-\\
  public Type_Extension_Class(Extension: string): string {
    return this.Icons_Image.find(item => item.Extension.toLowerCase() === Extension.toLowerCase())?.Class || 'not-found';
  }

  //-================== FUNCTTION FOR RETURN URL IMAGE ==================-\\
  public Type_Extension_Img(Extension: string): string {
    return this.Icons_Image.find(item => item.Extension.toLowerCase() === Extension.toLowerCase())?.Url_Image.toLowerCase() || 'not-found.png';
  }

  //-================== FUNCTTION FOR VERIFICATE IF UPDATE OR NEW MODAL ==================-\\
  public OpenModalIsUpdate(IsUpdate: boolean, RiskOpportunities: RiskOpportunities | null): void {
    this.IsUpdate = IsUpdate;
    if (RiskOpportunities !== null) this.RiskOpportunities_Selected = RiskOpportunities;

    this.ToggleModalAddRiskOpportunities(true);
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  public Cut_Name(NameRiskOpportunities: string): string {

    let NameRiskOpportunities_List = NameRiskOpportunities.split('.');
    NameRiskOpportunities_List.pop();

    const Name_Clen: string = NameRiskOpportunities_List.join('.');

    return Name_Clen.length > 40 ? Name_Clen.slice(0, 40) + '...' : Name_Clen;

  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR SEND AND UPDATE RISKOPPORTUNITIE =====================&\\

  //-================== FUNCTTION OPEN OR CLOSE MODAL ADD RISKOPPORTUNITIE ==================-\\
  public ToggleModalAddRiskOpportunities(CloseOrOpen: boolean): void {
    const ModalAddRiskOpportunities = document.getElementById('ModalAddRiskOpportunities') as HTMLElement;
    CloseOrOpen ? ModalAddRiskOpportunities.classList.add('active') : ModalAddRiskOpportunities.classList.remove('active');
  }

  //-================== FUNCTION FOR ADD CLASS HOVER INPUT FILE ==================-\\
  public Load_File(): void {
    const Drag_Drop = document.getElementById('Drag-Drop') as HTMLDivElement;
    Drag_Drop.classList.add('active');
  }

  //-================== FUNCTION FOR REMOVE CLASS HOVER INPUT FILE ==================-\\
  public Onload_File(): void {
    const Drag_Drop = document.getElementById('Drag-Drop') as HTMLDivElement;
    Drag_Drop.classList.remove('active');
  }

  //-================== FUNCTION TO CAPTURE FILE UPLOAD (RISKOPPORTUNITIE) ==================-\\
  public Load_Document_RiskOpportunities(data: Event): void {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {
      this.FileAuxAddRiskOpportunities = {
        FileData: file,
        FileName: file.name
      }


      !this.IsUpdate ? this.Send_RiskOpportunities() : this.Send_Update_RiskOpportunities();

    }
    this.Onload_File();
    this.MyInputAddRiskOpportunities.nativeElement.value = null;
  }

  //-================== FUNCTION FOR SEND NEW RISKOPPORTUNITIE ==================-\\
  private Send_RiskOpportunities(): void {

    const Create_RiskOpportunities: Create_RiskOpportunities = {
      Name: this.FileAuxAddRiskOpportunities.FileName,
      Extension: this.FileAuxAddRiskOpportunities.FileName.split('.').pop() || '',
      Status: 1,
      ID_Previous_Version: null,
    }

    Swal.fire({
      title: '¿Está seguro de cargar esta política de calidad?',
      text: `¡El nombre es ${this.FileAuxAddRiskOpportunities.FileName}!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Si, Cargar política de calidad!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        this.Animation_Modal_RiskOpportunities(true);

        const Container_Progress_RiskOpportunities = document.getElementById('Container-Progress-RiskOpportunities') as HTMLDivElement;
        Container_Progress_RiskOpportunities.classList.add('active');

        setTimeout(async () => {

          try {

            const ResRiskOpportunities: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Upload_RiskOpportunities(Create_RiskOpportunities));

            if (ResRiskOpportunities.success) {
              const RiskOpportunities: RiskOpportunities = ResRiskOpportunities.operation;

              await this.Send_File_Modal(RiskOpportunities);

              Container_Progress_RiskOpportunities.classList.remove('active');
              this.Animation_Modal_RiskOpportunities(false);
              this.ToggleModalAddRiskOpportunities(false);
              this.Load_Component();

              Swal.fire({
                icon: 'success',
                title: 'política de calidad cargada correctamente',
                confirmButtonColor: this.ColorConfirm
              })

            }

          } catch (e) {

            Swal.fire({
              title: 'Error al cargar',
              text: '¡No se guardo la política de calidad en el sistema, informa a tu supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            Container_Progress_RiskOpportunities.classList.remove('active');
            this.Animation_Modal_RiskOpportunities(false);
            this.ToggleModalAddRiskOpportunities(false);
            this.Load_Component();
          }
        }, 2500);


      }

    })

  }

  //-================== FUNCTION FOR SEND DATA RISKOPPORTUNITIE ==================-\\
  private Send_File_Modal(RiskOpportunities: RiskOpportunities): Promise<boolean> {

    return new Promise((resolve, reject) => {


      const TextProgress = document.getElementById('TextProgress') as HTMLDivElement;
      const Progress_Bar_RiskOpportunities = document.getElementById('Progress-Bar-RiskOpportunities') as HTMLDivElement;

      const File = new FormData();

      File.append('File_RiskOpportunities', this.FileAuxAddRiskOpportunities.FileData, encodeURIComponent(RiskOpportunities.ID + '.' + RiskOpportunities.Extension))

      try {

        this.Service_GeneralCDMS.Upload_RiskOpportunities_File(File).subscribe(async (event: any) => {

          if (event.status === 500) {

            Progress_Bar_RiskOpportunities.style.width = "0%";
            TextProgress.innerHTML = "0%";
            Swal.fire({
              title: 'Error en la política de calidad',
              text: '¡Ha ocurrido un error al cargar la política de calidad, informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

          }

          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar_RiskOpportunities.style.width = value + "%";
            TextProgress.innerHTML = value + "%";
          }

          if (event['body']) {
            Progress_Bar_RiskOpportunities.style.width = "0%";
            TextProgress.innerHTML = "0%";
            resolve(true);
          }

        })

      } catch (e) {
        Swal.fire({
          title: 'Error en política de calidad',
          text: '¡No se guardo política de calidad en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })

        reject(false);
      }

    })

  }

  //-================== FUNCTION FOR SEND RISKOPPORTUNITIE FILE  ==================-\\
  private Animation_Modal_RiskOpportunities(DiabledOrEnabled: boolean): void {
    const Pro_popup3 = document.getElementById('Pro-popup3') as HTMLDivElement;
    const Pro_inside3 = document.getElementById('Pro-inside3') as HTMLDivElement;
    const Pro_content3 = document.getElementById('Pro-content3') as HTMLDivElement;
    DiabledOrEnabled ? Pro_popup3.classList.add('active') : Pro_popup3.classList.remove('active');
    DiabledOrEnabled ? Pro_inside3.classList.add('active') : Pro_inside3.classList.remove('active');
    DiabledOrEnabled ? Pro_content3.classList.add('active') : Pro_content3.classList.remove('active');
  }

  //-================== FUNCTION FOR SEND UPDATE RISKOPPORTUNITIE ==================-\\
  private Send_Update_RiskOpportunities(): void {

    const Create_RiskOpportunities: Create_RiskOpportunities = {
      Name: this.FileAuxAddRiskOpportunities.FileName,
      Extension: this.FileAuxAddRiskOpportunities.FileName.split('.').pop() || '',
      Status: 1,
      ID_Previous_Version: this.RiskOpportunities_Selected.ID,
    }

    Swal.fire({
      title: '¿Está seguro de actualizar la política de calidad?',
      text: `¡El nombre es ${this.FileAuxAddRiskOpportunities.FileName}!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Si, actualizar política de calidad!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        this.Animation_Modal_RiskOpportunities(true);

        const Container_Progress_RiskOpportunities = document.getElementById('Container-Progress-RiskOpportunities') as HTMLDivElement;
        Container_Progress_RiskOpportunities.classList.add('active');

        setTimeout(async () => {

          try {

            const ResRiskOpportunities: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Upload_RiskOpportunities(Create_RiskOpportunities));

            if (ResRiskOpportunities.success) {
              const RiskOpportunities: RiskOpportunities = ResRiskOpportunities.operation;

              await this.Send_File_Modal(RiskOpportunities);

              Container_Progress_RiskOpportunities.classList.remove('active');
              this.Animation_Modal_RiskOpportunities(false);
              this.ToggleModalAddRiskOpportunities(false);
              this.Load_Component();

              Swal.fire({
                icon: 'success',
                title: 'política de calidad cargada correctamente',
                confirmButtonColor: this.ColorConfirm
              })

            }

          } catch (e) {

            Swal.fire({
              title: 'Error en política de calidad',
              text: '¡No se guardo política de calidad en el sistema, informa a tu supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            Container_Progress_RiskOpportunities.classList.remove('active');
            this.Animation_Modal_RiskOpportunities(false);
            this.ToggleModalAddRiskOpportunities(false);
            this.Load_Component();
          }
        }, 2500);


      }

    })

  }

  //&===================== END FUNCTIONS FOR SEND AND UPDATE RISKOPPORTUNITIE =====================&\\


  //&===================== FUNCTIONS FOR OPTION CARD =====================&\\


  //-============== FUNCTION FOR DOWNLOAD RISKOPPORTUNITIE ==============\\
  public async Download_RiskOpportunities(RiskOpportunities: RiskOpportunities): Promise<void> {

    try {

      const ResGetURLRiskOpportunities: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Get_URL_Download_RiskOpportunities({ ID: RiskOpportunities.ID }));

      if (ResGetURLRiskOpportunities.success) {

        const URL = ResGetURLRiskOpportunities.operation.URL_RiskOpportunities;

        const IsDownload = this.Download_File_RiskOpportunities(URL, RiskOpportunities.Name);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el RiskOpportunities, informa a tu supervisor!'
      })
    }

  }

  private async Download_File_RiskOpportunities(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
      const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;
      ProgressModal.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Table.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'RiskOpportunities descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el RiskOpportunities, informe a su supervisor!'
          })

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  public Delete_RiskOpportunities(RiskOpportunities: RiskOpportunities): void {

    let NameRiskOpportunities = RiskOpportunities.Name.split('.');
    NameRiskOpportunities.pop();

    const Name_Clen: string = NameRiskOpportunities.join('.');

    Swal.fire({
      title: 'Eliminar política de calidad',
      icon: 'warning',
      text: `¿Desea eliminar la política de calidad ${Name_Clen}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((async result => {

      if (result.isConfirmed) {

        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminarla escriba ${Name_Clen} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === Name_Clen.toLowerCase()) {

              try {

                const ResDelete: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Delete_RiskOpportunities_CDMS({ ID: RiskOpportunities.ID }));

                if (ResDelete.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'política de calidad eliminada',
                    text: '¡Se elimino correctamente la política de calidad!',
                    confirmButtonColor: this.ColorConfirm
                  });
                  this.Load_Component();
                }

              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Error al eliminar la política de calidad',
                  text: '¡No se eliminó la política de calidad, notifica a tu supervisor!',
                  confirmButtonColor: this.ColorConfirm
                });
                this.Load_Component();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre de la política de calidad para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }

    }))
  }

  //&===================== END FUNCTIONS FOR OPTION CARD =====================&\\


}
